module.exports = __webpack_public_path__ + "static/media/school.8b8c3fff.png";